
import { PageMeta } from '../../components/shared/PageMeta';
import { Navigation } from '../../components/feature/Navigation';
import { ProductHeroSection } from './components/ProductHeroSection';
import { FeaturesOverviewSection } from './components/FeaturesOverviewSection';
import { AIDetectionSection } from './components/AIDetectionSection';
import { TrainingNudgesSection } from './components/TrainingNudgesSection';
import { DashboardSection } from './components/DashboardSection';
import { IntegrationsSection } from './components/IntegrationsSection';
import { SecuritySection } from './components/SecuritySection';
import { FooterSection } from '../../components/feature/FooterSection';
import { MinimalAurora } from '../../components/feature/MinimalAurora';

export default function ProductPage() {
  return (
    <div className="min-h-screen relative bg-black">
      <PageMeta path="/product" />
      {/* Minimal Aurora Background */}
      <MinimalAurora />
      
      {/* Content */}
      <div className="relative z-10">
        <Navigation />
        <ProductHeroSection />
        <FeaturesOverviewSection />
        <AIDetectionSection />
        <TrainingNudgesSection />
        <DashboardSection />
        <IntegrationsSection />
        <SecuritySection />
        <FooterSection />
      </div>
    </div>
  );
}
